import React from 'react';

// Components
import ButtonExternalSource from '../button-external-source/button-external-source';

// Hooks
import useRichText from "../../hooks/api/useRichText";

function WithoutColorSection({ accentColor, description, title, backgroundColor, buttonTitle, buttonLink, buttonSecondTitle, secondButtonLink, showSecondButton, tail, newTab}) {
  const { parseBodyText } = useRichText();

  return (
    <section className={'pt-20 sm:pt-32 pb-16 sm:pb-28 px-5 sm:px-7 lg:px-28'} style={{ backgroundColor: backgroundColor }}>
      <div className={'flex flex-wrap justify-between'}>
          <div className={'lg:w-5/12'}>
              <h6 className={'relative pb-6 lg:pb-12 text-5xl sm:text-72px lg:text-7xl xl:text-8xl font-comp font-bold uppercase'} style={{ color: accentColor }}>
                {title}
                <span className={'absolute bottom-0 left-0.5 w-11 sm:w-93px lg:w-52 h-1 sm:h-5px lg:h-2.5'} style={{ backgroundColor: accentColor }}></span>
            </h6>
          </div>
          <div className={'mt-10 sm:mt-14 lg:mt-0 lg:w-2/4'}>
          <div className={`parsed-html_${tail} text-lg sm:text-28px lg:text-2xl font-sans text-base-color sm:tracking-close`}>
              {parseBodyText(description)}
          </div>
          
          {
            (buttonTitle && buttonLink) &&

              <div className={'flex flex-wrap justify-between items-end w-full'}>
                <ButtonExternalSource 
                  classnames={`${showSecondButton && 'px-5 mr-0 ls:mr-4'}`}
                  color={accentColor}
                  text={buttonTitle}
                  newTab={newTab}
                  url={buttonLink} />

                { showSecondButton  && 
                    <ButtonExternalSource 
                      classnames={`${showSecondButton && 'mt-6 ls:mt-8 px-5'}`}
                      color={accentColor}
                      text={buttonSecondTitle}
                      newTab={newTab}
                      url={secondButtonLink} /> }
                </div> 
            }
          </div>
      </div>
    </section>
  )
}

export default WithoutColorSection;
